import React from 'react';
import {Divider} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {StyledButton, StyledCard, StyledDescription, StyledTitle} from './styles';
import {OrientationCardType} from './types';

const {readMore} = translations['pt-br'].commons;

export const OrientationCard = ({orientations, handleClick}: OrientationCardType) => (
	<StyledCard data-test-id={`orientation-card-${orientations.id}`}>
		<StyledTitle variant="h6">{orientations.title}</StyledTitle>
		<Divider />
		<StyledDescription>{orientations.description}</StyledDescription>
		<StyledButton onClick={handleClick} variant="text" size="small" fullWidth>
			{readMore}
		</StyledButton>
	</StyledCard>
);
